import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";

// imports
import { Home, Courses, SingleCourse, Cart } from "./pages";
import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import VideoCoursePage from "./pages/VideoCoursePage";
import Recommendation from "./pages/Recommendation";
import { Auth0Provider } from "@auth0/auth0-react";
import { ReactNotifications } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import { Store } from "react-notifications-component";
import { useEffect } from "react";
import Feedback from "./pages/Feedback";

function App() {
  return (
    <Auth0Provider
      domain={`${process.env.REACT_APP_AUTH0_DOMAIN}`}
      clientId={`${process.env.REACT_APP_AUTH0_CLIENT_ID}`}
      authorizationParams={{
        redirect_uri: window.location.origin,
      }}
    >
      <BrowserRouter>
        <ReactNotifications />
        <Navbar />
        <Sidebar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/recommendation" element={<Recommendation />} />
          <Route path="/video/:id" element={<VideoCoursePage />} />
          <Route path="/courses/:id" element={<SingleCourse />} />
          <Route path="/category/:category" element={<Courses />} />
          <Route path="/cart" element={<Cart />} />
        </Routes>
      </BrowserRouter>
    </Auth0Provider>
  );
}

export default App;
